import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { environment } from '../../../environments/environment';

export class TranslateLocalLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<any> {
    const file: string = environment.i18nFile;
    return fromPromise(System.import(`../../../assets/i18n/${file}.${lang}.json`));
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/factories/translate-local-loader.ts